import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid} from '../question-helper';
import {NgxCurrencyConfig, NgxCurrencyInputMode} from 'ngx-currency';

declare const $: any;

@Component({
    selector: 'app-question-currency',
    templateUrl: './question-currency.component.html',
    styleUrls: ['./question-currency.component.scss'],
    standalone: false
})
export class QuestionCurrencyComponent implements OnInit, AfterViewInit {

  @Input() question: Question;
  @Input() readOnly = false;
  @Input() showLabel = true;
  @Input()  isEditModal = false;
  @Input() showLabelQuestionCopy = false;
  @Output() questionAnswer = new EventEmitter();

  uniqueControlName = `textbox-currency-${newGuid()}`;
  uniqueId = `textbox-currency-id-${newGuid()}`;
  value = 0;
  maskOptions: NgxCurrencyConfig;

  constructor() { }

  ngOnInit(): void {
    if (this.question?.answer) {
      this.value = +this.question.answer;
    }
  }

  ngAfterViewInit(): void {
    this.maskOptions = {
      max: this.question?.max_val ? this.question?.max_val : null,
      min: null,
      allowZero: true,
      nullable: false,
      inputMode: NgxCurrencyInputMode.Financial,
      align: 'left',
      allowNegative: false,
      prefix: '',
      decimal: '.',
      suffix: '',
      thousands: ' ',
      precision: 0
    };
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.question.currentValue) {
      this.question = changes.question.currentValue;
      if (this.question?.answer) {
        this.value = +this.question.answer;
      }
    }
  }
  saveValue(): void {
    // allowZero is true on the mask, so 0 is a legitimate answer, not "empty" - only
    // null/undefined (cleared) should blank the answer, otherwise it's always emitted
    // so the parent's Continue-enabled state stays in sync with what's actually on screen
    if (this.question) {
      this.question.answer = (this.value || this.value === 0) ? this.value.toString() : '';
      this.questionAnswer.emit(this.question);
    }
  }

}
